module.exports = __webpack_public_path__ + "static/media/1.eca12642.jpg";